import { type FC } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import CurrentSteps from "../../shared/layout/Steps";
import arrowBack from "../../assets/images/arrow-back.svg";
import { formatTranslation } from "../../shared/utils/translationUtils";

export interface TrialHeaderProps {
  isEditing: boolean;
  onBackClick: () => void;
  current: number;
  items: Array<{ key: string; title: string }>;
}

const TrialHeader: FC<TrialHeaderProps> = ({
  isEditing,
  onBackClick,
  current,
  items,
}) => {
  const { t } = useTranslation();

  return (
    <div className="header-main">
      <div className="breadcrumbs" data-testid="breadcrumbs-div">
        <Button className="Left-button-icon" onClick={onBackClick}>
          <img src={arrowBack} alt="left-icon" />
        </Button>
        <p>
          {isEditing
            ? formatTranslation(t("trials.edit"))
            : formatTranslation(t("trials.new"))}
        </p>
      </div>
      <div className="stepper-common">
        <CurrentSteps current={current} items={items} />
      </div>
    </div>
  );
};

export default TrialHeader;
